"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCommandLineArgv = parseCommandLineArgv;
const nativeModule = process.platform === 'win32'
    ? require('./Release/windows-argv-parser.node')
    : null;
function parseCommandLineArgv(commandLine) {
    if (!nativeModule) {
        throw new Error(`The windows-argv-parser module is only available on Windows`);
    }
    return nativeModule.parseCommandLineArgv(commandLine);
}
//# sourceMappingURL=index.js.map